import useToast from '@hooks/ui/useToast';
import useNativeListener from '@hooks/useNativeListener';
import { Permission } from '@models/permission';
import NativeUtil from '@utils/NativeUtil';

function useContact(onUpdate: (name: string, phone: string) => void) {
  const openContacts = () => {
    NativeUtil.postMessage('requestPermission', Permission.READ_CONTACT);
  };
  const toast = useToast();

  useNativeListener('requestPermission', (permission: Permission, result: boolean) => {
    if (permission === Permission.READ_CONTACT) {
      if (result) {
        NativeUtil.postMessage('getContacts', '');
      } else {
        toast.error('연락처 권한이 거부되었습니다.');
      }
    }
  });

  useNativeListener('setContacts', (name: string, phone: string) => {
    onUpdate(name, phone);
  }, [onUpdate]);
  return {
    openContacts,
  };
}

export default useContact;
